import React from "react";

import { DefaultHeroLayout } from "../Default";
import { Quote } from "../../../../../quoteForms";
import { HeroWithDefaultProps } from "../../variants/types";

export const DefaultWithQuote: React.FC<HeroWithDefaultProps> = ({
  children,
  formOpen,
  offersMode
}) => {
  if (formOpen || offersMode) {
    return <Quote />;
  }

  return <DefaultHeroLayout>{children}</DefaultHeroLayout>;
};
